"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMistoExperience() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221610" id="the-sunday-velvet-philosophy" className="bg-accent/40 text-foreground py-24 md:py-32 px-6 md:px-12 lg:px-24 overflow-hidden" ref={sectionRef}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
        
        {}
        <div className={`lg:col-span-6 relative transition-all duration-1000 ease-out ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="relative w-full aspect-[4/5] md:aspect-[3/4] lg:aspect-[4/5] max-w-md mx-auto lg:max-w-none lg:mr-12">
            {}
            <div className="absolute top-0 left-0 w-full h-[85%] rounded-t-full overflow-hidden shadow-2xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637664/img/soap_pouring_macro.png" alt="Macro shot of luxury soap being hand-poured" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-primary/5 mix-blend-overlay"></div>
            </div>
            
            {}
            <div className="absolute bottom-0 right-0 w-[65%] aspect-square rounded-2xl overflow-hidden shadow-3xl border-8 border-background z-10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637664/img/soap_texture_detail.png" alt="Detailed texture of a Sunday Velvet soap bar" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>

        {}
        <div className={`lg:col-span-6 flex flex-col justify-center transition-all duration-1000 delay-300 ease-out ${isSectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-sm font-default font-semibold tracking-widest uppercase text-primary mb-6">
            The Ritual
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-default font-medium leading-tight mb-10">
            The Velvet Standard
          </h3>
          
          <div className="font-default text-lg md:text-xl leading-relaxed text-muted-foreground space-y-6">
            <p>
              <span className="float-left text-[6rem] leading-[0.75] pr-4 pt-2 font-serif text-foreground font-light">
                S
              </span>
              UNDAY VELVET is a sanctuary for skin, offering handcrafted soaps that turn a simple shower into a sacred ritual. Each bar is meticulously hand-poured in small batches using skin-loving botanicals and ultra-pure minerals to ensure the highest quality for your daily care.
            </p>
            <p>
              Designed for the modern woman and luxury hospitality, our collections are sensitive-safe, hand-poured, and sustainably sourced. We believe in the art of slow living, creating elevated daily rituals that honor your skin and the earth through minimal, intentional design.
            </p>
          </div>

          <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-8">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637664/img/sunday_velvet_mark.png" alt="Sunday Velvet Brand Mark" className="h-16 object-contain opacity-90" />
            <div className="h-px w-12 bg-border hidden sm:block"></div>
            <Button asChild variant="outline" size="lg" className="rounded-full border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors">
              <Link to="#">
                Explore Our Story
              </Link>
            </Button>
          </div>
        </div>

      </div>
    </section>;
}